import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@services/user.service';
import { UserLoginLog } from '@models/user-login-log.model';

@Component({
  standalone: false,
  selector: 'app-user-access-log',
  templateUrl: './user-access-log.component.html',
  styleUrls: ['./user-access-log.component.scss']
})
export class UserAccessLogComponent implements OnInit {

  displayedColumns: string[] = ['attemptDate', 'ip', 'status'];
  dataSource = new MatTableDataSource<UserLoginLog>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    // Obtener el ID del usuario desde la URL
    this.route.params.subscribe(params => {
      const userId = params['userId']; // Extrae el ID del usuario de la URL
      if (userId) {
        this.loadUserLogs(userId);
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /**
   * Carga el historial de accesos del usuario
   */
  loadUserLogs(userId: string) {
    this.userService.getUserLoginLogs(userId).subscribe(
      (logs: UserLoginLog[]) => {
        this.dataSource.data = logs;
      },
      (error) => {
        console.error('Error obteniendo logs:', error);
      }
    );
  }
}
